import angular from 'angular';

import appContainer from './containers/app.container';
import rootContainer from './containers/root.container';
import routerContainer from './containers/router.container';
import app from './components/app/app.component';
import router from './components/router/router.component';
import locationProviderConfig from './configs/locationProvider.config';

const rootModule = angular.module('root', [])
.component('appContainer', appContainer)
.component('rootContainer', rootContainer)
.component('routerContainer', routerContainer)
.component('app', app)
.component('router', router)
.config(locationProviderConfig);

export default rootModule.name;
